module.exports = __webpack_public_path__ + "img/thought_balloon.8eb6281a.gif";